import { ThemeConfig } from 'antd'

export const defaultTheme = (customTheme: ThemeConfig): ThemeConfig => {
  return {
    token: {
      colorLink: '#4038dd',
      colorLinkActive: '#2725b8',
      colorLinkHover: '#998df7',
      colorPrimary: '#4038dd',
      fontFamily: "'Open Sans', sans-serif",
      colorInfo: '#4038dd',
      colorPrimaryHover: '#4038dd',
      colorPrimaryTextHover: '#4038dd',
      screenLG: 1300,
      screenLGMax: 1599,
      screenLGMin: 1300,
      screenMD: 1200,
      screenMDMax: 1200,
      screenXL: 1600,
      screenXLMax: 1919,
      screenXLMin: 1600,
      screenXXL: 1920,
      screenXXLMin: 1920,
      ...customTheme?.token,
    },
    components: {
      Tabs: {
        colorLink: '#4038dd',
        colorLinkActive: '#4038dd',
        colorLinkHover: '#4038dd',
        colorPrimary: '#4038dd',
        colorPrimaryHover: '#4038dd',
        colorPrimaryText: '#4038dd',
        colorPrimaryTextActive: '#4038dd',
        colorPrimaryTextHover: '#4038dd',
      },
      Menu: {
        groupTitleColor: '#4038dd',
        itemHoverColor: '#4038dd',
        horizontalItemHoverColor: '#4038dd',
        itemSelectedColor: '#4038dd',
        horizontalItemSelectedColor: '#4038dd',
        itemDisabledColor: '#4038dd',
        dangerItemColor: '#4038dd',
        dangerItemHoverColor: '#4038dd',
        dangerItemSelectedColor: '#4038dd',
        dangerItemSelectedBg: '#4038dd',
      },
      ...customTheme?.components,
    },
  }
}

export const darkTheme: ThemeConfig = {
  token: {
    colorLink: '#6c60eb',
    colorLinkActive: '#2725b8',
    colorLinkHover: '#998df7',
  },
  components: {
    Tabs: {
      colorLink: '#6c60eb',
      colorLinkActive: '#6c60eb',
      colorLinkHover: '#6c60eb',
      colorPrimary: '#6c60eb',
      colorPrimaryHover: '#6c60eb',
      colorPrimaryText: '#6c60eb',
      colorPrimaryTextActive: '#6c60eb',
      colorPrimaryTextHover: '#6c60eb',
    },
    Menu: {
      groupTitleColor: '#6c60eb',
      itemHoverColor: '#6c60eb',
      horizontalItemHoverColor: '#6c60eb',
      itemSelectedColor: '#6c60eb',
      horizontalItemSelectedColor: '#6c60eb',
      itemDisabledColor: '#6c60eb',
      dangerItemColor: '#6c60eb',
      dangerItemHoverColor: '#6c60eb',
      dangerItemSelectedColor: '#6c60eb',
      dangerItemSelectedBg: '#6c60eb',
    },
    DatePicker: {
      cellHoverWithRangeBg: '#302694',
    },
  },
}
